import { isEmpty } from 'lodash'
import { useRecordContext } from 'react-admin'

import StaticText from './StaticText'
import { useShowStyles } from '../resources/common/show'

const NFCCardsField = () => {
  const { nfc_cards: nfcCards } = useRecordContext()
  const showClasses = useShowStyles()

  if (isEmpty(nfcCards)) {
    return <StaticText>n/a</StaticText>
  }
  return (
    <ul style={showClasses.unorderedList}>
      {nfcCards.map(({ card_id: cardId, nfc_type: nfcType }) => (
        <li key={cardId} style={showClasses.unorderedListItem}>
          <p>
            {cardId} ({nfcType})
          </p>
        </li>
      ))}
    </ul>
  )
}

export default NFCCardsField
